import { Loader2 } from 'lucide-react';

import { cn } from '@/lib/utils';

const SIZE_CLASSES = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-8 w-8',
} as const;

export interface LoadingSpinnerProps {
  size?: keyof typeof SIZE_CLASSES;
  className?: string;
  /** Screen-reader label; defaults to "Loading". */
  label?: string;
}

/**
 * Mirrors `apps/admin-ui/src/components/shared/LoadingSpinner.tsx`: an
 * `aria-hidden` decorative icon inside an element that carries the accessible
 * "Loading" status.
 */
export function LoadingSpinner({ size = 'md', className, label = 'Loading' }: LoadingSpinnerProps) {
  return (
    <span
      role="status"
      aria-live="polite"
      className={cn('inline-flex items-center justify-center', className)}
    >
      <Loader2
        className={cn('animate-spin motion-reduce:animate-none', SIZE_CLASSES[size])}
        aria-hidden="true"
      />
      <span className="sr-only">{label}</span>
    </span>
  );
}
